module.exports = __webpack_public_path__ + "img/header.dee2bf0b.jpg";